module.exports = __webpack_public_path__ + "static/img/BackTop.8100045.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/BackTop.png
// module id = l1/L
// module chunks = 60